import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import { Button, ButtonToolbar } from 'react-bootstrap';
import Dropzone from 'react-dropzone';

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    this.props.editProfileImage(this.props.profile.user.id, acceptedFiles);
  }
  render() {
    const profile = this.props.profile;
    const name = `${profile.user.first_name} ${profile.user.last_name}`;
    const optProps = {
      size: 64,
      round: true,
      ...(profile.image && { src: profile.image }),
      ...(profile.custom_image && { src: profile.custom_image }),
    };
    const image = (
      <Dropzone
        accept="image/*"
        ref={node => {
          this.dropzone = node;
        }}
        onDrop={this.onDrop}
        multiple={false}
        className="profile-change ignore"
        acceptClassName="drop-accept"
        rejectClassName="drop-reject"
      >
        <Avatar name={name} color="#326a34" {...optProps} className="avatar" />
      </Dropzone>
    );
    return (
      <div>
        <h2>
          {image}
          {name}
        </h2>
        <h2>{this.props.profile.title}</h2>
        <p>
          <i className="fa fa-envelope-o" /> {this.props.profile.user.email}
        </p>
        <p>
          <i className="fa fa-mobile" /> {this.props.profile.mobile}
        </p>
        <p>
          <i className="fa fa-building" /> {this.props.profile.office}
        </p>
        <ButtonToolbar>
          <Button onClick={this.props.gotoProfileEdit} bsStyle="info">
            Edit Profile
          </Button>
          <Button onClick={this.props.gotoProfilePassword} bsStyle="info">
            Set Password
          </Button>
        </ButtonToolbar>
        <p>To remove your account please email us at deletedata@usecatch.com</p>
      </div>
    );
  }
}

Profile.propTypes = {
  profile: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
    mobile: PropTypes.string,
    office: PropTypes.string,
    title: PropTypes.string,
    custom_image: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  gotoProfilePassword: PropTypes.func.isRequired,
  gotoProfileEdit: PropTypes.func.isRequired,
  editProfileImage: PropTypes.func.isRequired,
};
Profile.defaultProps = {
  profile: {
    id: null,
  },
};

export default Profile;



// WEBPACK FOOTER //
// src/routes/profile/components/Profile.js